<template>
  <div>
    <q-dialog v-model="dialogPesquisas" persistent>
      <q-card style="width: 700px; max-width: 80vw;">
        <q-toolbar class="bg-primary text-white shadow-2">
          <q-toolbar-title>Pesquisas</q-toolbar-title>
        </q-toolbar>
        <q-card-section>
          {{stringPesquisasDisponoveis}}
        </q-card-section>
        <q-card-section>
          <q-list bordered separator>
            <q-item
              v-for="(pesquisa, idx) of pesquisas"
              :key="idx"
              clickable
              @click="responderPesquisa(pesquisa._id)"
            >
              <q-item-section avatar>
                <q-icon color="primary" name="question_answer" />
              </q-item-section>
              <q-item-section>
                <q-item-label>{{pesquisa.nome}}</q-item-label>
                <q-item-label caption>Responder até {{pesquisa.validade | date}}</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-card-section>
        <q-separator />
        <q-card-actions align="right">
          <q-btn v-close-popup flat color="red" label=" responder mais tarde" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <ResponderPesquisa
      :idPesquisa="idPesquisaSelecionada"
      ref="responderPesquisa"
      @on-save="onSaveRespostas"
    />
  </div>
</template>

<script>
import { getMinhasPesquisas } from '../../services/pesquisa'
import ResponderPesquisa from './ResponderPesquisa'

export default {
  data () {
    return {
      pesquisas: [],
      dialogPesquisas: false,
      idPesquisaSelecionada: ''
    }
  },
  mounted () {
    this.getMinhasPesquisas()
  },
  methods: {
    async getMinhasPesquisas () {
      try {
        this.pesquisas = await getMinhasPesquisas()
        if (this.pesquisas.length) {
          this.dialogPesquisas = true
          return
        }

        this.dialogPesquisas = false
      } catch (error) {
        console.error(error)
      }
    },

    responderPesquisa (idPesquisa) {
      this.idPesquisaSelecionada = idPesquisa
      setTimeout(() => {
        this.$refs.responderPesquisa.open()
      }, 50);
    },

    onSaveRespostas () {
      this.getMinhasPesquisas()
    }
  },

  computed: {
    stringPesquisasDisponoveis () {
      if (this.pesquisas.length > 1) {
        return `Você tem ${this.pesquisas.length} novas pesquisas disponíveis!`
      }

      return `Você tem ${this.pesquisas.length} nova pesquisa disponível!`
    }
  },

  components: {
    ResponderPesquisa
  }
}
</script>